export default {"src":"/_next/static/media/m4.9eecb208.svg","height":83,"width":237,"blurWidth":0,"blurHeight":0};